var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z",
    fill: "#0077B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6005 12.4236V22.6372H7.20117V12.4236H10.6005Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8242 9.26419C10.8242 10.2449 10.086 11.0296 8.90074 11.0296H8.87902C7.73779 11.0296 7 10.2449 7 9.26419C7 8.26275 7.76026 7.5 8.92315 7.5C10.086 7.5 10.8022 8.26275 10.8242 9.26419Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8596 16.7811L22.8595 22.6372H19.4603V17.173C19.4603 15.8005 18.9684 14.8639 17.7378 14.8639C16.7987 14.8639 16.2393 15.4953 15.9936 16.1051C15.9037 16.3237 15.8817 16.6282 15.8817 16.9334V22.6375H12.4819C12.4819 22.6375 12.5267 13.3823 12.4819 12.4239H15.8817V13.8706C16.3328 13.1752 17.1409 12.1838 18.9457 12.1838C21.1826 12.1838 22.8596 13.6439 22.8596 16.7811Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c86169eeb3850db099c2f6728d250d4e.svg";
export { ForwardRef as ReactComponent };